/*@ngInject*/
const FormMediator = function ($q, $timeout, delayShowNextRequiredFieldModel, formRepository,
                               formTemplateRepository, persistentConnection, fieldType,
                               loadFieldInstanceListRepository, formViewerModel,
                               createFieldInstanceRepository, updateFieldInstanceRepository,
                               loadRowInstanceListRepository, addFormRowRepository, authorizationConstants,
                               deleteFormRowRepository, deleteFormSummaryInstanceRepository,
                               remoteFunctionRepository, formSnippetsRepository, formTemplateStatus,
                               formInstanceRepository, closeFormRepository, loadUserDetailsRepository,
                               formSnippetBlobRepository, classCodeFormatRepository, classCodeItemsRepository, classCodeGroupingsRepository,
                               registrationRepository, formRegistrationModel, addDeleteRepeatingFormConfigRepository,
                               formSummaryRepository, timingModel, formViewerConstant, uiFormTemplateRepository,
                               dragModel, getUiFieldListRepository, currentUserModel, uuidUtil) {

    let pendingFieldRequestQueue = [],
        activeFieldRequest = false;

    this.getFormsByRootFormId = function (rootFormId) {
        let defer = $q.defer();

        persistentConnection.connect().then(function () {

            function handleSuccess(result) {
                defer.resolve(result);
            }

            function handleError(error) {
                defer.reject(error);
            }

            formRepository.getFormsByRootFormId(rootFormId).then(handleSuccess, handleError);
        });

        return defer.promise;
    };

    this.getFormInstanceById = function (formId) {
        return formInstanceRepository.getFormInstanceById(formId);
    };

    this.loadStaticForm = function (uiFormTemplateId) {
        timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.LOAD_DATA);

        uiFormTemplateRepository.getUiFormTemplateById(uiFormTemplateId).then(function (uiFormTemplate) {
            let hasManageFormsRole = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

            formViewerModel.buildStaticForm(uiFormTemplateId, uiFormTemplate, hasManageFormsRole);
        });
    };

    this.loadRootForm = function (formId, printPreview, effectiveDate, submissionId, currencyCode) {
        let formTemplateIdList,
            formInstanceIdList,
            formSummaryList,
            hasWriteAccess;

        timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.LOAD_DATA);

        this.getFormsByRootFormId(formId).then((rootFormResult) => {
            formSummaryList = rootFormResult.formSummaries;
            hasWriteAccess = rootFormResult.hasWriteAccess;
            formTemplateIdList = _.map(formSummaryList, 'formTemplateId');
            formInstanceIdList = _.map(formSummaryList, function (formSummary) {
                return {
                    formSummaryId: formSummary.id,
                    objectUri: formSummary.objectUri
                };
            });

            this.loadFormData(formId, formSummaryList, formTemplateIdList, formInstanceIdList, hasWriteAccess, false, printPreview, effectiveDate, submissionId, currencyCode);
        });
    };

    this.loadFormData = function (rootFormId, formSummaryList, formTemplateIdList, formInstanceIdList, hasWriteAccess, isSupplementalForm, printPreview, effectiveDate, submissionId, currencyCode) {
        let formRowInstanceList,
            uiFormTemplateList,
            fieldInstanceList;

        function loadRowInstanceList(formInstanceIdList) {
            let rowInstanceList = [],
                promiseList = [];

            _.each(formInstanceIdList, function (instance) {
                let promise = loadRowInstanceListRepository.loadRowInstanceList(instance.formSummaryId, instance.objectUri)
                    .then(function (result) {
                        rowInstanceList = _.concat(rowInstanceList, result);
                    });

                promiseList.push(promise);
            });

            // wait until all async calls are complete
            $q.all(promiseList).then(function () {
                formRowInstanceList = rowInstanceList;

                formTemplateRepository.loadUIFormTemplates(formTemplateIdList).then(function (result) {
                    uiFormTemplateList = result;
                    loadFieldInstanceList(formInstanceIdList);
                });
            });
        }

        function loadFieldInstanceList(formInstanceIdList) {
            let instanceList = [],
                promiseList = [];

            _.each(formInstanceIdList, function (instance) {
                let promise = loadFieldInstanceListRepository.loadFieldInstanceList(instance.formSummaryId, instance.objectUri)
                    .then(function (result) {

                        if (!result) {
                            result = [];
                        }

                        instanceList = _.concat(instanceList, result);
                    });

                promiseList.push(promise);
            });

            // wait until all async calls are complete
            $q.all(promiseList).then(function () {
                fieldInstanceList = instanceList;

                function onAllFormDataReady() {

                    timingModel.addMilestone(formViewerConstant.timing.FORM_VIEWER, formViewerConstant.timing.BEGIN_RENDERING);

                    if (isSupplementalForm) {
                        formViewerModel.addSupplementalForm(rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview, currencyCode);
                    } else {
                        formSnippetsRepository.getFormSnippets(rootFormId).then((snippets) => {
                            formViewerModel.buildForm(rootFormId, uiFormTemplateList, fieldInstanceList, formSummaryList, formRowInstanceList, hasWriteAccess, printPreview, snippets, effectiveDate, submissionId, currencyCode);
                        });
                    }
                }

                $timeout(function () {
                    onAllFormDataReady();
                }, 1, false);
            });
        }

        loadRowInstanceList(formInstanceIdList);
    };


    this.createSupplementalForm = function (form, formId, printPreview) {
        let formSummaryList = [form],
            hasWriteAccess = true,
            isSupplementalForm = true,
            formTemplateIdList = _.map(formSummaryList, 'formTemplateId'),
            formInstanceIdList = _.map(formSummaryList, function (formSummary) {
                return {
                    formSummaryId: formSummary.id,
                    objectUri: formSummary.objectUri
                };
            });

        this.loadFormData(formId, formSummaryList, formTemplateIdList, formInstanceIdList, hasWriteAccess, isSupplementalForm, printPreview);
    };

    this.deleteSupplementalForm = function (supplementalForm, rootFormId) {
        return formViewerModel.deleteSupplementalForm(supplementalForm, rootFormId);
    };

    this.processRootFormUpdate = function (rootForm, rootFormId) {
        formViewerModel.processRootFormUpdate(rootForm, rootFormId);
    };

    this.getFormStructure = function (rootFormId) {
        return formViewerModel.getFormStructure(rootFormId);
    };

    this.closeForm = function (rootFormId) {
        return closeFormRepository.closeForm(rootFormId);
    };

    this.importForms = function (submissionId, formId, uploadType, formTemplateName, file) {
        return formSummaryRepository.importForms(submissionId, formId, uploadType, formTemplateName, file);
    };

    this.loadFormTemplates = function (formTemplateIdList) {
        return formTemplateRepository.loadUIFormTemplates(formTemplateIdList);
    };

    this.createFieldInstance = function (formId, instance) {
        return createFieldInstanceRepository.createFieldInstance(formId, instance);
    };

    this.updateFieldInstance = function (formId, instance) {
        return updateFieldInstanceRepository.updateFieldInstance(formId, instance);
    };

    this.processFieldUpdate = function (fieldModel, rootFormId) {
        return formViewerModel.processFieldUpdate(fieldModel, rootFormId);
    };

    this.processFieldDelete = function (fieldModel, rootFormId) {
        return formViewerModel.processFieldDelete(fieldModel, rootFormId);
    };

    this.processFieldRename = function (fieldModel, rootFormId) {
        return formViewerModel.processFieldRename(fieldModel, rootFormId);
    };

    this.addRepeatingRow = function (formId, uiRowId, rowNumberOfLastRow) {
        return addFormRowRepository.addFormRow(formId, uiRowId, rowNumberOfLastRow);
    };

    this.deleteRepeatingRow = function (deleteRepeatingRows) {
        return deleteFormRowRepository.deleteFormRow(deleteRepeatingRows);
    };

    this.processRemoteRowDeletion = function (message, rootFormId) {
        formViewerModel.processRemoteRowDeletion(message.messagePayload, rootFormId);

        _.each(message.deleteFieldMessages, (deleteFieldMessage) => {
            this.processFieldDelete(deleteFieldMessage, rootFormId);
        });

        _.each(message.renameFieldMessages, (renameFieldMessage) => {
            this.processFieldRename(renameFieldMessage, rootFormId);
        });

        _.each(message.createFieldMessages, (createFieldMessage) => {
            this.processFieldUpdate(createFieldMessage, rootFormId);
        });

        _.each(message.updateFieldMessages, (updateFieldMessage) => {
            this.processFieldUpdate(updateFieldMessage, rootFormId);
        });
    };

    this.processRemoteRowAddition = function (message, rootFormId) {
        formViewerModel.processRemoteRowAddition(message.messagePayload.uiRowId, message.messagePayload, rootFormId);

        _.each(message.deleteFieldMessages, (deleteFieldMessage) => {
            this.processFieldDelete(deleteFieldMessage, rootFormId);
        });

        _.each(message.renameFieldMessages, (renameFieldMessage) => {
            this.processFieldRename(renameFieldMessage, rootFormId);
        });

        _.each(message.createFieldMessages, (createFieldMessage) => {
            this.processFieldUpdate(createFieldMessage, rootFormId);
        });

        _.each(message.updateFieldMessages, (updateFieldMessage) => {
            this.processFieldUpdate(updateFieldMessage, rootFormId);
        });
    };

    this.processRemoteRowUpdate = function (message, rootFormId) {
        if (message.messagePayload) {
            formViewerModel.processRemoteRowUpdate(message.messagePayload.uiRowId, message.messagePayload, rootFormId);
        }
        _.each(message.deleteFieldMessages, (deleteFieldMessage) => {
            this.processFieldDelete(deleteFieldMessage, rootFormId);
        });

        _.each(message.renameFieldMessages, (renameFieldMessage) => {
            this.processFieldRename(renameFieldMessage, rootFormId);
        });

        _.each(message.createFieldMessages, (createFieldMessage) => {
            this.processFieldUpdate(createFieldMessage, rootFormId);
        });

        _.each(message.updateFieldMessages, (updateFieldMessage) => {
            this.processFieldUpdate(updateFieldMessage, rootFormId);
        });
    };

    this.sortRowRepeater = function (rootFormId, rowRepeaterId, sortKey, sortType) {
        formViewerModel.sortRowRepeater(rootFormId, rowRepeaterId, sortKey, sortType);
    };

    this.processCollapsibleColumnsAndVisibility = function (rowRepeaterId, rootFormId) {
        formViewerModel.processCollapsibleColumnsAndVisibility(rowRepeaterId, rootFormId);
    };

    this.checkFieldRequestQueue = function () {
        if (pendingFieldRequestQueue.length > 0) {
            let nextRequest = _.head(pendingFieldRequestQueue);
            pendingFieldRequestQueue = _.drop(pendingFieldRequestQueue);

            this.makeFieldRequest(nextRequest.formId, nextRequest.fieldStructure, nextRequest.errorCallback, nextRequest.successCallback);
        }
    };

    this.makeFieldRequest = function (formId, fieldStructure, errorCallback, successCallback) {
        let hasFieldModel = !_.isUndefined(fieldStructure.fieldModel.id),
            newInstanceConfig;

        activeFieldRequest = true;

        function getFieldName() {
            let result = fieldStructure.uiField.fieldTemplate.variableName;

            if (fieldStructure.rowRepeaterId && fieldStructure.rowNumber > 0) {
                result += ':' + fieldStructure.rowNumber;
            }

            return result;
        }

        if (hasFieldModel) {
            this.updateFieldInstance(fieldStructure.fieldModel.id, fieldStructure.fieldModel)
                .then(successCallback, errorCallback)
                .finally(() => {
                    activeFieldRequest = false;
                    this.checkFieldRequestQueue();
                });
        } else {
            newInstanceConfig = {
                name: getFieldName(),
                value: fieldStructure.fieldModel.value,
                formId: formId
            };
            if (fieldStructure.fieldModel.valueLabel) {
                newInstanceConfig.valueLabel = fieldStructure.fieldModel.valueLabel;
            }
            this.createFieldInstance(formId, newInstanceConfig)
                .then(successCallback, errorCallback)
                .finally(() => {
                    activeFieldRequest = false;
                    this.checkFieldRequestQueue();
                });
        }
    };

    this.handleFieldChange = function (formId, fieldStructure, errorCallback, successCallback) {
        if (activeFieldRequest) {
            pendingFieldRequestQueue.push({
                formId: formId,
                fieldStructure: fieldStructure,
                errorCallback: errorCallback,
                successCallback: successCallback
            });
        } else {
            this.makeFieldRequest(formId, fieldStructure, errorCallback, successCallback);
        }
    };

    this.setDelayShowNextRequiredField = function (value) {
        delayShowNextRequiredFieldModel.setDelayShowNextRequiredField(value);
    };

    this.isDelayShowNextRequiredField = function () {
        return delayShowNextRequiredFieldModel.isDelayShowNextRequiredField();
    };

    this.resetDelayShowNextRequiredField = function () {
        delayShowNextRequiredFieldModel.reset();
    };

    this.addFormSummaryRow = function (formId, submissionId, formTemplateName, addFormInstanceFunctionButtonExecutorName) {
        let params = {
            formTemplateName: formTemplateName
        };
        if (!addFormInstanceFunctionButtonExecutorName) {
            addFormInstanceFunctionButtonExecutorName = 'addFormInstanceFunctionButtonExecutor';
        }
        return remoteFunctionRepository.executeFunction(formId, submissionId, addFormInstanceFunctionButtonExecutorName, null/*fieldId*/, params);
    };

    this.deleteFormSummaryRow = function (formId) {
        return deleteFormSummaryInstanceRepository.deleteFormSummaryRow(formId);
    };

    this.shouldProcessForm = function (rootFormId, eventFormId) {
        return formViewerModel.shouldProcessForm(rootFormId, eventFormId);
    };

    this.getFormSnippets = function (rootFormId) {
        return formSnippetsRepository.getFormSnippets(rootFormId);
    };

    this.getSnippetBlob = function (snippetId) {
        return formSnippetBlobRepository.getSnippetBlob(snippetId);
    };

    this.executeFunction = function (formId, submissionId, beanName, fieldId, paramMap) {
        return remoteFunctionRepository.executeFunction(formId, submissionId, beanName, fieldId, paramMap);
    };

    this.getClassCodeItems = function (type, query, effectiveDate) {
        return classCodeItemsRepository.getClassCodeItems(type, query, effectiveDate);
    };

    this.getClassCodeItemsNoDate = function (type, query) {
        return classCodeItemsRepository.getClassCodeItemsNoDate(type, query);
    };

    this.getClassCodeGroupings = function (type, effectiveDate) {
        return classCodeGroupingsRepository.getClassCodeGroupings(type, effectiveDate);
    };

    this.getClassCodeFormat = function (classCodeType) {
        return classCodeFormatRepository.getClassCodeFormat(classCodeType);
    };

    this.getFormSummaryAddDeleteConfigByFormSummaryInstanceId = function (formId, formSummaryInstanceId) {
        return addDeleteRepeatingFormConfigRepository.getAddDeleteConfigByFormSummaryInstanceId(formId, formSummaryInstanceId);
    };

    this.getFormSummaryAddDeleteConfigByFormSummaryGridFieldName = function (formId, formSummaryGridFieldName) {
        return addDeleteRepeatingFormConfigRepository.getAddDeleteConfigByFormSummaryGridFieldName(formId, formSummaryGridFieldName);
    };

    this.updateFieldStructureConfiguration = function (fieldStructure, suppressFormEvents) {
        return formViewerModel.updateFieldStructureConfiguration(fieldStructure, suppressFormEvents);
    };

    this.unregisterForm = function (formId) {
        formViewerModel.resetForm(formId);
        _.each(formRegistrationModel.getRegistrations(formId), function (url) {
            registrationRepository.deleteRegistration(url);
        });
        formRegistrationModel.removeRegistrations(formId);
    };

    this.createField = function (rootFormId, dropConfiguration, dropZoneFieldId) {
        return formViewerModel.createField(rootFormId, dropConfiguration, dropZoneFieldId);
    };

    this.moveField = function (rootFormId, elementToMoveId, dropZoneFieldId, moveType) {
        return formViewerModel.moveField(rootFormId, elementToMoveId, dropZoneFieldId, moveType);
    };

    this.moveSection = function (rootFormId, elementToMoveSectionId, dropZoneSectionId, moveType) {
        return formViewerModel.moveSection(rootFormId, elementToMoveSectionId, dropZoneSectionId, moveType);
    };

    this.moveRow = function (rootFormId, elementToMoveRowId, dropZoneRowId, moveType) {
        return formViewerModel.moveRow(rootFormId, elementToMoveRowId, dropZoneRowId, moveType);
    };

    this.createSection = function (rootFormId, dropConfiguration, dropZoneFieldId, insertLocation) {
        return formViewerModel.createSection(rootFormId, dropConfiguration, dropZoneFieldId, insertLocation);
    };

    this.createRowRepeater = function (rootFormId, dropConfiguration, dropZoneRowId, insertLocation) {
        return formViewerModel.createRowRepeater(rootFormId, dropConfiguration, dropZoneRowId, insertLocation);
    };

    this.updateUiFormTemplate = function (uiFormTemplate, id) {
        return uiFormTemplateRepository.updateFormTemplate(uiFormTemplate, id);
    };

    this.deleteField = function (rootFormId, formStructureId) {
        return formViewerModel.deleteField(rootFormId, formStructureId);
    };

    this.deleteSection = function (rootFormId, sectionStructureId) {
        formViewerModel.deleteSection(rootFormId, sectionStructureId);
    };

    this.deleteRow = function (rootFormId, rowStructureId) {
        formViewerModel.deleteRow(rootFormId, rowStructureId);
    };

    this.findReferenceCountByFieldTemplateId = function (fieldTemplateId) {
        return uiFormTemplateRepository.findReferenceCountByFieldTemplateId(fieldTemplateId);
    };

    this.getCurrentDragItem = function () {
        return dragModel.getCurrentDragItem();
    };

    this.setCurrentDragItem = function (newDragConfig) {
        dragModel.setCurrentDragItem(newDragConfig);
    };

    this.getUiFieldList = function (formTemplateType) {
        return getUiFieldListRepository.getUiFieldList(formTemplateType);
    };

    this.getUiFieldByType = function (uiFieldType, formTemplateType) {
        let defer = $q.defer(),
            uiField;

        this.getUiFieldList(formTemplateType).then(function (uiFieldMap) {
            uiField = _.cloneDeep(uiFieldMap[uiFieldType]);
            uiField.id = -1;
            uiField.fieldTemplate.id = -1;
            uiField.fieldTemplate.variableName = 'let_' + uuidUtil.generateUUID();
            defer.resolve(uiField);
        });

        return defer.promise;
    };

    this.getUiFormStructureList = function () {
        return getUiFieldListRepository.getUiFormStructureList();
    };

    this.buildRowRepeaterTemplate = function (formTemplateType) {
        let defer = $q.defer(),
            promiseList = [],
            uiFormStructureList,
            uiFieldList,
            uiRowTemplate,
            uiRowRepeaterTemplate,
            uiTextInputTemplate;

        promiseList.push(this.getUiFormStructureList().then(function (result) {
            uiFormStructureList = result;
        }));

        promiseList.push(this.getUiFieldList(formTemplateType).then(function (result) {
            uiFieldList = result;
        }));

        promiseList.push(this.getUiFieldByType(fieldType.ROWREPEATER, formTemplateType).then(function (result) {
            uiRowRepeaterTemplate = result;
        }));

        promiseList.push(this.getUiFieldByType(fieldType.TEXT_INPUT, formTemplateType).then(function (result) {
            uiTextInputTemplate = result;
            uiTextInputTemplate.hideLabel = true;
        }));

        $q.all(promiseList).then(() => {
            uiRowTemplate = uiFormStructureList[formViewerConstant.configuration.formStructureType.ROW_REPEATER];
            uiRowTemplate.id = -1;
            uiRowTemplate.ordering = 0;
            uiRowTemplate.repeaterField = uiRowRepeaterTemplate;
            uiRowTemplate.fields = [uiTextInputTemplate, uiRowTemplate.repeaterField];
            defer.resolve(_.cloneDeep(uiRowTemplate));
        });

        return defer.promise;
    };

    this.buildEmptySectionTemplate = function (formTemplateType) {
        let defer = $q.defer();

        this.buildNewUiSectionList(formTemplateType).then(function (sectionList) {
            defer.resolve(_.cloneDeep(sectionList[0]));
        });

        return defer.promise;
    };

    this.buildEmptyUiRowTemplate = function () {
        let defer = $q.defer();

        this.getUiFormStructureList().then(function (uiFormStructureList) {
            let uiRowTemplate = _.clone(uiFormStructureList[formViewerConstant.configuration.formStructureType.ROW]);
            uiRowTemplate.id = -1;
            defer.resolve(uiRowTemplate);
        });

        return defer.promise;
    };

    this.buildNewUiSectionList = function (formTemplateType) {
        let defer = $q.defer(),
            sections = [],
            promiseList = [],
            uiFormStructureList,
            uiFieldList,
            uiSectionTemplate,
            uiRowTemplate;

        promiseList.push(this.getUiFormStructureList().then(function (result) {
            uiFormStructureList = result;
        }));

        promiseList.push(this.getUiFieldList(formTemplateType).then(function (result) {
            uiFieldList = result;
        }));

        $q.all(promiseList).then(() => {
            uiSectionTemplate = _.clone(uiFormStructureList[formViewerConstant.configuration.formStructureType.SECTION]);
            uiRowTemplate = _.clone(uiFormStructureList[formViewerConstant.configuration.formStructureType.ROW]);

            this.getUiFieldByType(fieldType.LABEL, formTemplateType).then(function (uiField) {
                uiRowTemplate.id = -1;
                uiRowTemplate.ordering = 0;
                uiRowTemplate.fields.push(uiField);

                uiSectionTemplate.id = -1;
                uiSectionTemplate.ordering = 0;
                uiSectionTemplate.rows.push(uiRowTemplate);

                sections.push(uiSectionTemplate);

                defer.resolve(sections);
            });


        });

        return defer.promise;
    };

    this.clearIdsFromSectionList = function (sections) {
        _.each(sections, function (section) {
            delete section.id;
            _.each(section.rows, function (row) {
                delete row.id;
                _.each(row.fields, function (field) {
                    delete field.id;
                    delete field.fieldTemplate.id;
                });
            });
        });
    };
};

angular.module('umFormViewer')
    .service('formMediator', FormMediator);
